import { render } from "./footerfile.vue?vue&type=template&id=41092fb8"
import script from "./footerfile.vue?vue&type=script&lang=js"
export * from "./footerfile.vue?vue&type=script&lang=js"

import "./footerfile.vue?vue&type=style&index=0&id=41092fb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__